import React, { useEffect, useState } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";

const TeacherLayout = () => {
  const [teachers, setTeachers] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const breadcrumb = {
    current_section: "Gestione insegnante",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione insegnante", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools`,
          fetchOptions
        );
        const result = await response.json();

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchoolOptions(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchSchools();
  }, []);

  useEffect(() => {
    if (!selectedSchool) {
      setTeachers([]);
      return;
    }
    const fetchTeachers = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllTeachers?schoolId=${
            selectedSchool ?? ""
          }`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          console.error(result.error);
          setTeachers([]);
          return;
        }
        setTeachers(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTeachers();
  }, [selectedSchool]);

  const redirectToAddTeacher = () => {
    window.location.href = "/teachers/add?schoolId=" + selectedSchool;
  };

  const disableTeacher = async (id) => {
    if (
      !window.confirm("Sei sicuro di voler disabilitare questo insegnante?")
    ) {
      return;
    }

    try {
      const fetchOptions = getFetchOptions("application/json", [], "DELETE");
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/disableTeacher?userId=${id}`,
        fetchOptions
      );
      const result = await response.json();
      if (result.error) {
        alert(`Errore durante la disabilitazione dell'insegnante`);
        console.error(result.error);
        return;
      }
      alert("Insegnante disabilitato con successo.");
      setTeachers((prevTeachers) =>
        prevTeachers.filter((teacher) => teacher.id !== id)
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleResetPassword = async (email) => {
    const fetchOptions = getFetchOptions(
      "application/json",
      { email: email },
      "POST"
    );
    try {
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/sendResetPasswordEmail`,
        fetchOptions
      );
      const result = await response.json();
      if (!result.error) {
        alert("Email di reset password inviata con successo.");
      } else {
        console.error("Error sending reset password email:", result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <div className="card custom-card">
        <div className="card-header">Gestione insegnanti</div>
        <div className="card-body">
          <Select
            options={schoolOptions}
            id="school"
            name="school"
            value={schoolOptions?.filter(function (option) {
              return option.value === selectedSchool;
            })}
            onChange={(e) => setSelectedSchool(e?.value)}
            classNames={"form-control"}
            placeholder="Scegli scuola..."
            isSearchable
            isClearable
          />
        </div>
      </div>

      {/* Teachers List */}
      <div className="card custom-card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Insegnanti</div>
            <div>
              <div className="d-flex justify-content-end">
                <button
                  onClick={redirectToAddTeacher}
                  type="button"
                  className="btn btn-primary text-uppercase"
                >
                  <i className="bi bi-plus-circle-fill"></i> Nuovo
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table text-nowrap table-bordered"
              id="datatable-basic"
            >
              <thead>
                <tr>
                  <th scope="col" width="10">
                    #
                  </th>
                  <th scope="col">Nome e Cognome</th>
                  <th scope="col">Codice Fiscale</th>
                  <th scope="col">Email</th>

                  {/*<th scope="col">Scuole di appartenenza</th>*/}

                  {/* <th scope="col">Materie di insegnamento</th> */}
                  <th scope="col">Azioni</th>
                </tr>
              </thead>
              <tbody>
                {teachers?.map((teacher, index) => (
                  <tr key={teacher.id}>
                    <td>{index + 1}</td>
                    <td>{teacher.nominativo}</td>
                    <td>{teacher.cf}</td>
                    <td>{teacher.email}</td>
                    {/* <td>{teacher.materia}</td> */}
                    <td>
                      <div className="btn-list">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() =>
                            (window.location.href = `/teachers/edit/${teacher.id}`)
                          }
                        >
                          <i className="align-middle bi bi-pencil"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => disableTeacher(teacher.id)}
                        >
                          <i className="align-middle bi bi-trash"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-info"
                          onClick={() =>
                            (window.location.href = `/teachers/detail/${teacher.id}`)
                          }
                        >
                          <i className="align-middle bi bi-eye"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-secondary"
                          title="Invia email di reset password"
                          onClick={() => {
                            if (
                              window.confirm(
                                "Sei sicuro di voler inviare la mail di reset password a questo utente?"
                              )
                            ) {
                              handleResetPassword(teacher.email);
                            }
                          }}
                        >
                          <i className="align-middle bi bi-send"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherLayout;
